// Formatting + status palette helpers shared across estimates/jobs/invoices.

export const money = (v) =>
    `$${Number(v || 0).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    })}`;

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString() : "—");
export const fmtDateTime = (iso) => (iso ? new Date(iso).toLocaleString() : "—");

export const ESTIMATE_STATUSES = ["draft", "sent", "viewed", "accepted", "rejected", "expired"];
export const JOB_STATUSES = ["scheduled", "in_progress", "completed", "invoiced", "paid"];
export const INVOICE_STATUSES = ["draft", "sent", "partial", "paid", "overdue"];
export const SERVICE_TYPES = ["interior", "exterior", "commercial", "specialty"];
export const UNITS = ["sq_ft", "linear_ft", "hours", "each"];
export const EXPENSE_CATEGORIES = ["materials", "labor", "equipment", "other"];
export const PAYMENT_METHODS = ["cash", "check", "card", "bank_transfer"];

export const statusBadgeClass = (status) =>
    ({
        // estimates
        draft: "badge-muted",
        sent: "badge-new",
        viewed: "badge-warning",
        accepted: "badge-success",
        rejected: "badge-error",
        expired: "badge-muted",
        // jobs (some shared with estimates)
        scheduled: "badge-new",
        in_progress: "badge-warning",
        completed: "badge-success",
        invoiced: "badge-quoted",
        paid: "badge-paid",
        // invoices
        partial: "badge-warning",
        overdue: "badge-error",
    }[status] || "badge-muted");

export const StatusBadge = ({ status, testId }) => (
    <span
        className={`badge-pill ${statusBadgeClass(status)}`}
        data-testid={testId || `status-badge-${status}`}
    >
        {String(status || "").replace("_", " ")}
    </span>
);
